import { combineReducers } from 'redux';
// import { reducer as form } from 'redux-form'

import app from 'containers/App/reducer';
import channels from 'containers/ChannelsPage/reducer';
import account from 'containers/AccountPage/reducer';
import modal from 'containers/RootModal/reducer';
import signUp from 'containers/SelfSignUp/reducer';
import forgotPassword from 'containers/ForgotPasswordPage/reducer';
import leads from 'containers/LeadsPage/reducer';
import gallery from 'containers/GalleryPage/reducer';
import signIn from 'containers/SignInPage/reducer';

const CLEAR_STATE = '@@mvbth/CLEAR_STATE';

export const clearState = () => ({ type: CLEAR_STATE });

const appReducer = combineReducers({
  app,
  channels,
  account,
  // form,
  modal,
  signUp,
  forgotPassword,
  leads,
  gallery,
  signIn,
});

const createReducer = (state, action) =>
  action.type === CLEAR_STATE
    ? appReducer(undefined, action)
    : appReducer(state, action);

export default createReducer;
